var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterDataMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49652 20.1098L2.8252 5.54177C4.52751 1.85248 10.8558 2.32584 13.1262 1.75826C14.9424 1.30419 21.5897 4.13333 22.0627 5.54177C22.1258 9.98786 21.6219 19.126 21.0921 20.1098C20.43 21.3396 12.3891 22.9478 11.4432 23.2316C10.6864 23.4586 5.83007 21.245 3.49652 20.1098Z",
    fill: "#5D5FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none",
    d: "M3.4873 14.0031C3.4873 14.0031 3.4873 17.0197 3.4873 19.1529C3.4873 21.2861 7.52221 23.0153 12.4995 23.0153C17.4768 23.0153 21.5117 21.2861 21.5117 19.1529C21.5117 18.0882 21.5117 14.0031 21.5117 14.0031",
    stroke: "#5D5FEF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none",
    d: "M3.4873 6.27832C3.4873 6.27832 3.4873 10.5824 3.4873 12.7156C3.4873 14.8488 7.52221 16.578 12.4995 16.578C17.4768 16.578 21.5117 14.8488 21.5117 12.7156C21.5117 11.6509 21.5117 6.27832 21.5117 6.27832",
    stroke: "#5D5FEF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 10.1408C17.4772 10.1408 22.5451 8.41152 22.5451 6.27839C22.5451 4.14526 17.4772 2.41602 12.4999 2.41602C7.52255 2.41602 2.64453 4.14526 2.64453 6.27839C2.64453 8.41152 7.52255 10.1408 12.4999 10.1408Z",
    stroke: "#F2F1FE",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53027 12.527C6.25837 18.38 19.7968 17.2994 23.5874 12.527",
    stroke: "#F2F1FE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterDataMenuIconFilled);
export default __webpack_public_path__ + "static/media/MasterDataMenuIconFilled.1f766983bb23c6f36a6645ad204fa98f.svg";
export { ForwardRef as ReactComponent };